import { render, staticRenderFns } from "./ChatMessageContainer.vue?vue&type=template&id=393b3398&"
import script from "./ChatMessageContainer.vue?vue&type=script&lang=js&"
export * from "./ChatMessageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports